import React from 'react';
import './Services.css';
import constructionImage from '../img/resid_construction.jpg';
import { Link } from 'react-router-dom'; // Import Link

const Services = () => {
  const servicesData = [
    {
      title: 'Residential Construction',
      description: [
        'Building beautiful, sustainable homes with expert craftsmanship.',
        'We manage your project efficiently from start to the final touches.',
        'Attention to detail ensures your dream home becomes a reality.',
      ],
      buttonText: 'Know More',
      linkTo: '/residential-construction',
    },
    {
      title: 'Commercial Construction',
      description: [
        'Creating state-of-the-art commercial spaces with modern design.',
        'We use high-quality materials for durable and impressive structures.',
        'Comprehensive project delivery tailored to your specific business needs.',
      ],
      buttonText: 'Consult the Expert',
      linkTo: '/commercial-construction',
    },
    {
      title: 'Renovations',
      description: [
        'Transforming your existing space with professional renovation services.',
        'Customized designs to modernize your living or working environment.',
        'Quality upgrades that enhance both aesthetics and functionality.',
      ],
      buttonText: 'Know More',
      linkTo: '/renovations',
    },
    {
      title: 'House Construction',
      description: [
        'Providing end-to-end services for constructing your new house.',
        'We handle everything from the initial foundation to the final finishes.',
        'Ensuring your home is built with quality and designed to last for years.',
      ],
      buttonText: 'Consult the Expert',
      linkTo: '/house-construction',
    },
    {
      title: 'Footing Construction',
      description: [
        'Our expert team ensures solid and stable footings for your building.',
        'Critical foundation work performed with precision and high quality.',
        'Providing the essential groundwork for long-lasting and secure structures.',
      ],
      buttonText: 'Know More',
      linkTo: '/footing-construction',
    },
  ];

  return (
    <section className="service-section">
      <h2>Our Construction Services</h2> {/* Added a main heading */}
      <div className="service-card-grid"> {/* Added the grid container */}
        {servicesData.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={constructionImage} alt={service.title} className="service-image" />
            <div className="service-content">
              <h3>{service.title}</h3> {/* Changed h2 to h3 for card titles */}
              <ul>
                {service.description.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
              <Link to={service.linkTo} className="service-card-link"> {/* Updated button class name */}
                {service.buttonText}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;